import { AppSettings } from "../../../../app-setting";

function MainSubHeaderComponent() {
  return (
    <div className="main-sub-header-container">
      <div className="container bds-container">
        <div className="bds-sub-header-inner">
          <span className="bds-tagline">
            {AppSettings.bdsName} &mdash; Connecting Hoosiers with disabilities to services, supports, and their best life.
          </span>
        </div>
      </div>
    </div>
  );
}

export const MainSubHeader = MainSubHeaderComponent;
